const NS = 'TablesListFilter';

export default function TablesListFilter($filter) {
  "ngInject";

  return (tables, tablesLookup) => {
    if (!tables || !tables.length) {
      return '';
    }
    let tableNames = [];
    tables.forEach(table => {
      if (table && table.name) {
        if (tablesLookup && tablesLookup.get(table._id)) {
          const tableValueFromLookup = tablesLookup.get(table._id);
          tableNames.push('T' + tableValueFromLookup.name); // https://nowbookit.atlassian.net/browse/NBI-4728 Hotfix where the updated table name was not getting picked. - we need to choose the latest name from the tableLookup.
        } else {
          tableNames.push('T' + table.name);
        }

      }
    });
    tableNames = $filter('alphaSortFilter')(tableNames);
    return tableNames.join(', ');
  }
}
